import { Box, ModuleBase, Text, Stack, ResponsiveImage } from '@/components';
import classNames from 'classnames';
import { SideBySideModuleModel } from './SideBySideModule';

const GlobalDataPower = (data: SideBySideModuleModel) => {
  const { alignment, title, description, image } = data.props;

  return (
    <ModuleBase
      data={{ ...data, props: { ...data.props, backgroundColour: alignment === 'Right' ? '#f1f0e9' : '' } }}
      className="GlobalDataPower"
    >
      <Stack
        className={classNames(
          'xxl:gap-40 relative container flex flex-col gap-10 xl:gap-25',
          alignment === 'Right' ? 'lg:flex-row-reverse' : 'lg:flex-row',
        )}
      >
        <div className="flex w-full flex-col gap-5 lg:w-1/2 xl:gap-10">
          {title && (
            <Text
              className="color-from-bg text-style-h3 pr-10 md:pr-20 lg:pr-0 xl:!text-[50px] xl:!leading-[55px]"
              dangerouslySetInnerHTML={{ __html: title }}
            />
          )}

          <div className="color-from-bg relative flex w-fit flex-col">
            {description && <Text className="text-style-h4" dangerouslySetInnerHTML={{ __html: description }} />}
          </div>
        </div>

        <Box className={classNames('w-full lg:w-1/2', alignment === 'Right' ? 'xl:pl-3' : 'xl:pr-3')}>
          {image && image.desktopImage && (
            <ResponsiveImage
              image={image.desktopImage}
              widths={{ xs: 380, sm: 500, md: 520, lg: 456, xl: 576, xxl: 900 }}
              heights={{ xs: 210, sm: 280, md: 290, lg: 350, xl: 384, xxl: 600 }}
            />
          )}
        </Box>
      </Stack>
    </ModuleBase>
  );
};

export default GlobalDataPower;
